import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';

interface IProps {
    q: string;
}

export const useGetLatestTrxQuery = ({ q }: IProps) => {
  const { customerId } = useStore(state => state.user);
  return useQuery(
    'useGetLatestTrxQuery',
    async () => {
      const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/bucket/emergency/transactions?${q}`);
      return res.data.transactionList;
    },
    {
      enabled: true,
      cacheTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
    },
  );
};
